import React from 'react';
import './modalPopup.scss';

/**
 * The MainNavBar component.
 */
export class ModalPopup extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
    this.stopVideo = this.stopVideo.bind(this);
  }

  stopVideo(){

    var exitVideo = this.refs.exitVideo;
    console.log(exitVideo);
    var vidSrc = exitVideo.getAttribute('src');
    exitVideo.setAttribute('src','');
    exitVideo.setAttribute('src',vidSrc);
  }


  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    return (
      <div className="modalWrapper" onClick={this.stopVideo.bind(this)}>

        <div className="modal fade" id="exitIntentModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel"
             aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content">


              <div className="modal-body">

                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div className="embed-responsive embed-responsive-16by9">
                  <iframe ref="exitVideo" className="embed-responsive-item" src="https://player.vimeo.com/video/311117633/" id="video" allowscriptaccess="always"></iframe>
                </div>


              </div>

            </div>
          </div>
        </div>


        <button type="button" id="exitModalBtn" className="btn btn-primary video-btn" data-toggle="modal"
                 data-target="#exitIntentModal">
          Play Vimeo Video
        </button>
      </div>
    );
  }
}



export default ModalPopup;



// WEBPACK FOOTER //
// ./src/components/common/modalPopup/modalPopup.js